import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-close\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<polygon points=\"15.53 7.04 12 10.58 8.5 7.08 7.08 8.49 10.58 11.99 7.05 15.53 8.47 16.95 12 13.41 15.54 16.95 16.95 15.53 13.42 12 16.95 8.46 15.53 7.04\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol